import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import type { MonthlyStats } from '../../../services/dashboardService';

type StatKey = 'schools' | 'classes' | 'teachers' | 'students';

const STAT_LABELS: { key: StatKey; label: string }[] = [
  { key: 'schools', label: 'Trường học mới' },
  { key: 'classes', label: 'Lớp học mới' },
  { key: 'teachers', label: 'Giáo viên mới' },
  { key: 'students', label: 'Học sinh mới' },
];

interface QuickStatsProps {
  // Số tạo mới theo tháng, sắp xếp cũ → mới; phần tử cuối là tháng hiện tại.
  monthlyStats: MonthlyStats[];
}

const QuickStats: React.FC<QuickStatsProps> = ({ monthlyStats }) => {
  const current = monthlyStats[monthlyStats.length - 1];
  const previous = monthlyStats[monthlyStats.length - 2];

  const renderChange = (key: StatKey) => {
    if (!previous) return null;

    // So bằng chênh lệch tuyệt đối vì tháng trước bằng 0 thì không tính được %.
    const diff = current[key] - previous[key];
    const Icon = diff > 0 ? TrendingUp : diff < 0 ? TrendingDown : Minus;
    const color = diff > 0 ? 'text-green-600' : diff < 0 ? 'text-red-600' : 'text-gray-600';

    return (
      <div className="flex items-center">
        <Icon className={`h-4 w-4 mr-1 ${color}`} />
        <span className={`text-sm font-medium ${color}`}>
          {diff > 0 ? '+' : ''}{diff}
        </span>
        <span className="text-xs text-gray-500 ml-1">so với tháng trước ({previous[key]})</span>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Thống kê nhanh {current && <span className="text-sm font-normal text-gray-500">({current.month.toLowerCase()})</span>}
      </h3>
      {current ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {STAT_LABELS.map(({ key, label }) => (
            <div key={key} className="p-4 bg-gray-50 rounded-lg">
              <div className="text-sm font-medium text-gray-600 mb-2">{label}</div>
              <div className="text-2xl font-bold text-gray-900 mb-1">{current[key].toLocaleString()}</div>
              {renderChange(key)}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">Chưa có dữ liệu thống kê theo tháng.</p>
      )}
    </div>
  );
};

export default QuickStats;
